(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ceto-subgate"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ceto-subgate]');
    if (!button) return;
    const note = document.getElementById(button.getAttribute('aria-controls'));
    if (!note) return;
    note.hidden = false;
    button.setAttribute('aria-expanded', 'true');
  });
  } catch(e) { console.error(e); }
})();

})();
